<div>
  <div class="page-title">
    <h1>
      Product Dimensions
      <button class="btn btn-primary" (click)="openModal()">Create New</button>
    </h1>
  </div>
  <div class="page-body">
    <div class="card mt-3">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" *ngIf="dataSource.data.length>0">

<!-- Checkbox Column -->
<!-- <ng-container matColumnDef="select">
  <th mat-header-cell *matHeaderCellDef>
    <mat-checkbox (change)="$event ? masterToggle() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()">
    </mat-checkbox>
  </th>
  <td mat-cell *matCellDef="let row">
    <mat-checkbox (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(row) : null"
                  [checked]="selection.isSelected(row)">
    </mat-checkbox>
  </td>
</ng-container> -->
        
        <!-- Name Column -->

        <ng-container matColumnDef="productNo">
          <th mat-header-cell *matHeaderCellDef> Product Number </th>
          <td mat-cell *matCellDef="let element"> {{element.productNo}} </td>
        </ng-container>
        
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Product Name </th>
          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>
        
        <ng-container matColumnDef="dimUnit">
          <th mat-header-cell *matHeaderCellDef> Dim Unit </th>
          <td mat-cell *matCellDef="let element"> {{element.dimUnit}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="length">
          <th mat-header-cell *matHeaderCellDef> Length </th>
          <td mat-cell *matCellDef="let element"> {{element.length}} </td>
        </ng-container>

        <ng-container matColumnDef="width">
          <th mat-header-cell *matHeaderCellDef> Width </th>
          <td mat-cell *matCellDef="let element"> {{element.width}} </td>
        </ng-container>

        <ng-container matColumnDef="height">
          <th mat-header-cell *matHeaderCellDef> Height </th>
          <td mat-cell *matCellDef="let element"> {{element.height}} </td>
        </ng-container>

        <ng-container matColumnDef="weightUnit">
          <th mat-header-cell *matHeaderCellDef> WeightUnit </th>
          <td mat-cell *matCellDef="let element"> {{element.weightUnit}} </td>
        </ng-container>

        <ng-container matColumnDef="weight">
          <th mat-header-cell *matHeaderCellDef> Weight </th>
          <td mat-cell *matCellDef="let element"> {{element.weight}} </td>
        </ng-container>
        
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let element"> 
            <i class="icon-pencil icon-btn" (click)="openModal(element.id)"></i> </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <h4 class="text-center" *ngIf="!(dataSource.data.length>0)">No Records Found</h4>
      <mat-paginator #paginator [length]="total" [pageSizeOptions]="[10, 50, 100]"   [pageSize]="tableModel.limit"  showFirstLastButtons 
      (page)="onPaginate($event)">
      </mat-paginator>
    </div>
  </div>
</div>